import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteRolesFromAPI, fetchRolesFromAPI, uploadRoleFileToAPI } from "../../../services/RoleService";


export const fetchRoles = createAsyncThunk(
  "roles/fetchRoles",
  async ({ page, perPage, search, columnFilters, sort }, { rejectWithValue }) => {
    try {
      const response = await fetchRolesFromAPI(page, perPage, search, columnFilters, sort);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data role");
    }
  }
);


export const deleteRole = createAsyncThunk(
  "roles/deleteRole",
  async (roleId, { rejectWithValue }) => {
    try {
      const response = await deleteRolesFromAPI(roleId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data role");
    }
  }
);

// Upload Role File
export const uploadRoleFile = createAsyncThunk(
  "roles/uploadRoleFile",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await uploadRoleFileToAPI(formData);
      return response;
    } catch (error) {
      return rejectWithValue({
        message: error?.message || "Upload gagal.",
        detail: error?.detail || [],
        status: error?.status || "failed"
      });
    }
  }
);


const roleSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    roleSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    active: 0,
    vendorRoles: 0,
    keywordSearch:"",
    columnFilters: {} // New state for column-specific filters
  },
  reducers: {
    setSearchRole: (state, action) => {
      state.roleSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
    setColumnFilters: (state, action) => {
      state.columnFilters = action.payload;
    },
    resetRoleState: (state) => {
      state.roles = [];
      state.currentPage = 1;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        const roles = action.payload.data.roles;
        state.loading = false;
        state.roles = roles.data;
        state.currentPage = roles.current_page;
        state.lastPage = roles.last_page;
        state.perPage = roles.per_page;
        state.firstItem = roles.from;
        state.totalCount = roles.total;
        state.active = roles.active ?? 0;
        state.vendorRoles = roles.vendorRoles ?? 0;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.roles = state.roles.filter(role => role.id !== action.payload);
      })
      .addCase(deleteRole.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(uploadRoleFile.pending, (state) => {
        state.loading = true;
      })
      .addCase(uploadRoleFile.fulfilled, (state, action) => {
        state.loading = false;
        // Optionally refresh the role list after successful upload
        // You can dispatch fetchRoles here if needed
      })
      .addCase(uploadRoleFile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setSearchRole, setPage, setVisibilityFilter, setPerPage, setKeywordSearch, setColumnFilters, resetRoleState } = roleSlice.actions;
export default roleSlice.reducer;
